import api from '@/config/api'
import moment from 'moment'

const state = {
	exchangeRates: null
}

const mutations = {
	setExchangeRate: (state, users) => {
		state.users = users
	}
}

const actions = {
	async getExchangeRate (store, { currencyId, date, exchangeType }) {
		return new Promise(async (resolve, reject) => {
			try {
 				if (!currencyId || !date) {
					return resolve(null)
				}

				let date2 = date
				try { date2 = moment(date).format('YYYY-MM-DD') } catch (err) { }

				const { data } = await api.get(`ExChangeRates/GetExChangeRate?ExChangeType=${exchangeType}&CurrencyId=${currencyId}&Date=${date2}`)
				resolve(data)
			} catch (error) { reject(error) }
		})
	},
	async calculateExchangeAmount (store, { amount, fromCurrencyId, toCurrencyId, date }) {
		return new Promise(async (resolve, reject) => {
			try {
				if (!date || !fromCurrencyId || !toCurrencyId || !date) {
					return resolve(null)
				}
				if (toCurrencyId === fromCurrencyId) {
					return resolve(amount)
				}
				let date2 = date
				try { date2 = moment(date).format('YYYY-MM-DD') } catch (err) { }

				const { data } = await api.get(`ExChangeRates/CalculateExchange?Amount=${amount}&FromCurrencyId=${fromCurrencyId}&ToCurrencyId=${toCurrencyId}&Date=${date2}`)
				resolve(data)
			} catch (error) {
				reject(error)
			}
		})
	},
	async getParite (store, { fromCurrencyId, toCurrencyId, date }) {
		return new Promise(async (resolve, reject) => {
			try {
				// eğer detay aktif değilse hesaplama ypamaya gerek yok
				if (!date || !fromCurrencyId || !toCurrencyId || toCurrencyId === fromCurrencyId) {
					return resolve(1)
				}
				if (toCurrencyId === fromCurrencyId) {
					return resolve(1)
				}
				let date2 = date
				try { date2 = moment(date).format('YYYY-MM-DD') } catch (err) { }

				const { data } = await this.$http.get(`ExChangeRates/GetParite?FromCurrencyId=${fromCurrencyId}&ToCurrencyId=${toCurrencyId}&Date=${date2}`)
				resolve(data)
			} catch (error) {
				reject(error)
			}
		})
	}

}

const getters = {
	exchangeRates: (state) => {
		return state.exchangeRates
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}



// WEBPACK FOOTER //
// ./src/store/modules/ExchangeRate.js